import { render, staticRenderFns } from "./CreateSuggestion.vue?vue&type=template&id=7af9324c&"
import script from "./CreateSuggestion.vue?vue&type=script&lang=ts&"
export * from "./CreateSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports